import React from 'react';

interface DateInputProps {
  label: string;
  value: string;
  required?: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
}

const DateInput: React.FC<DateInputProps> = ({ label, value, required, disabled, onChange }) => (
  <div className="mb-3">
    <label className="form-label">
      {label}
      {required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
    </label>
    <input
      type="date"
      className="form-control"
      value={value || ''}
      required={required}
      disabled={disabled}
      onChange={e => onChange(e.target.value)}
    />
  </div>
);

export default DateInput;
